import './Input.css';

import React from 'react';

interface InputProps {
  value: string;
  onValueChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error: string | null;
  disabled?: boolean;
}

const Input: React.FC<InputProps> = ({ value, onValueChange, error, disabled = false }) => {
  return (
    <div className="">
      <input
        disabled={disabled}
        data-testid="from-address"
        role="textbox"
        type="text"
        value={value}
        onChange={onValueChange}
        className={`input-field ${error ? 'error' : ''}`}
      />
      {error && <p className="input-error-text absolute font-sans">{error}</p>}
    </div>
  );
};

export { Input };
